//权限管理
import http from '../jslibs/axios/http';

// 权限管理 用户列表
export const getAuthList = data => http.post('/admin/admin.admin/getAdminList', data);

// 权限管理 新增用户http://127.0.0.1:18806/admin/admin.admin/addAdminItem
export const addAdminUser = data => http.post('/admin/admin.admin/addAdminItem', data);

// 权限管理 编辑用户
export const editAuthUser = data => http.post('/admin/admin.admin/setAdminItem', data);
// 权限管理 删除用户http://127.0.0.1:18806/admin/admin.admin/delAdminItem
export const delAuthUser = data => http.post('/admin/admin.admin/delAdminItem',data);

// 权限管理 获取权限列表
export const LimitsList = data => http.get('/cms/AdminAuthMenu', data);


// 身份管理 获取权限列表（添加/编辑）
export const getPermissionList = data => http.get('/cms/AdminAuthMenu', data);

export const getAdminAuthMenuTree = data => http.get('/cms/AdminAuthMenuTree');



// 权限管理 获取用户详情http://127.0.0.1:18806/admin/admin.admin/getAdminItem
export const getAuthListDetail = data => http.post('/admin/admin.admin/getAdminItem',data);
// 权限管理 获取权限详情
export const getMenuListDetail = uuid => http.get(`/cms/AdminAuthMenu/${uuid}`);


// 权限管理 菜单下拉框
export const getPermissionselect = data => http.get('/cms/AdminAuthMenuSelectList', data);



// 权限管理 添加身份http://127.0.0.1:18806/admin/admin.group/save
export const addLimitsUser = data => http.post('/admin/admin.group/save', data);
// 权限管理 编辑身份 http://127.0.0.1:18806
export const SetLimitsList = data => http.post('/admin/admin.group/update', data);
// 权限管理 删除身份  http://127.0.0.1:18806/admin/admin.group/del
export const delLimitsUser = data => http.post('/admin/admin.group/del',data);

// 权限管理 根据身份id查权限http://127.0.0.1:18806
export const getIdentityPerssion = data => http.get('/admin/admin.group/read',data);

// 权限管理 获取身份详情
export const getIdentityDetail = id => http.get(`/cms/AdminAuthGroup/${id}`);

// 权限管理 身份下拉框
export const getIdentityselect = data => http.get('/cms/AdminAuthGroupSelect', data);



// 权限管理 获取身份列表
export const identityOf = data => http.get('/admin/admin.group/index', data);
// 菜单列表
export const getMenuList = data => http.post('/admin/admin.menu/index', data);

//菜单详情
export const readMenu = data => http.post('/admin/admin.menu/read', data);

// 权限管理 添加权限http://127.0.0.1:18806/admin/admin.menu/save
export const addMenu = data => http.post('/admin/admin.menu/save', data);

// 权限管理 编辑权限http://127.0.0.1:18806/admin/admin.menu/update
export const SetMenu = data => http.post('/admin/admin.menu/update', data);
// 权限管理 删除权限http://127.0.0.1:18806/admin/admin.menu/delete
export const delMenu = data => http.post('/admin/admin.menu/delete',data);

// 权限管理 操作日志 http://127.0.0.1:18806/admin/admin.action_log/index
export const getLog = data => http.post('/admin/admin.action_log/index', data);

//清空日志
export const clearLog = data => http.post('/admin/admin.action_log/clear', data);
